import { InquiryCustomCakeSize } from "../InquiryCustomCakeSize.js";
import { Locale, type LocalizedString } from "../Locale.js";
import { customCakePrices } from "../customCakePrices.js";

export const inquiryCustomCakeSizeNameMap: Record<InquiryCustomCakeSize, LocalizedString> = {
	[InquiryCustomCakeSize.Portions12]: {
		[Locale.cs]: `12 porcí - jedno patro - od ${customCakePrices[InquiryCustomCakeSize.Portions12]},-`,
	},
	[InquiryCustomCakeSize.Portions18]: {
		[Locale.cs]: `18 porcí - jedno patro - od ${customCakePrices[InquiryCustomCakeSize.Portions18]},-`,
	},
	[InquiryCustomCakeSize.Portions25]: {
		[Locale.cs]: `25 porcí - dvě patra - od ${customCakePrices[InquiryCustomCakeSize.Portions25]},-`,
	},
	[InquiryCustomCakeSize.Custom]: {
		[Locale.cs]: "Více porcí - individuální cena",
	},
};
